const breadcrumb = {
  stock_bot: {
    index: 'Stock Bot',
    panoramica: 'Overview',
    dettagli: 'Details',
  },
  teccom: {
    dispatch_advices_index: 'TecCom dispatch advices (DDT)',
    order_confirmations_index: 'TecCom order confirmations',
  },
  carbody: {
    catalogue_sync_new: 'New sync',
    catalogue_sync_run: 'Sync status',
    catalogue_sync_history: 'Sync history',
    catalogue_order: 'Order export catalogue',
  },
}

export default breadcrumb
